import type { ReactElement } from 'react';
import '../common/DesignSystem.css';

export interface PersonaRange {
  readonly label: string;
  /** Percent of travelers, 0-100. */
  readonly minPct: number;
  readonly maxPct: number;
  readonly estimatePct: number;
  readonly color: string;
}

/** The scale runs 0% to 50%; wider values clamp to the right edge. */
const SCALE_MAX = 50;

function position(pct: number): number {
  return (Math.min(Math.max(pct, 0), SCALE_MAX) / SCALE_MAX) * 100;
}

export function PersonaDistributionBar({ label, minPct, maxPct, estimatePct, color }: PersonaRange): ReactElement {
  const left = position(minPct);
  const width = Math.max(position(maxPct) - left, 0);
  return (
    <div className="fl-persona" role="img" aria-label={`${label}: ${minPct.toFixed(0)} to ${maxPct.toFixed(0)} percent, estimate ${estimatePct.toFixed(0)} percent`}>
      <span className="fl-persona-label">{label}</span>
      <span className="fl-persona-track">
        <span className="fl-persona-range" style={{ left: `${left}%`, width: `${width}%`, background: color }} />
      </span>
      <span className="fl-persona-value">{estimatePct.toFixed(0)}%</span>
    </div>
  );
}

export function PersonaScale(): ReactElement {
  return (
    <div className="fl-persona-scale" aria-hidden="true">
      <span />
      <span>
        <span>0%</span>
        <span>25%</span>
        <span>50%</span>
      </span>
      <span />
    </div>
  );
}
